import openSocket from "socket.io-client";
import { getBackendUrl } from "../config";

function connectToSocket() {
	//let URL = getBackendUrl();
	//console.log("connectToSocket",URL); //DESATEL
    return openSocket(getBackendUrl());
}

export default connectToSocket;